import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Projects from './views/Projects.vue';
import Team from './views/Team.vue';
import Contact from './views/Contact.vue';
import Meta from 'vue-meta';

Vue.use(Router);
Vue.use(Meta);

export default new Router({
	mode: 'history',
	// eslint-disable-next-line no-undef
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home
		},
		{
			path: '*',
			name: '404',
			component: Home
		},
		{
			path: '/projects',
			name: 'projects',
			component: Projects
			// component: () => import('./views/Projects.vue')
		},
		{
			path: '/directors',
			name: 'directors',
			component: Team
			// component: () => import('./views/Team.vue')
		},
		{
			path: '/contact',
			name: 'contact',
			component: Contact
			// component: () => import('./views/Contact.vue')
		},
		{
			path: '/contacts',
			name: 'contacts',
			component: Contact
			// component: () => import('./views/Contact.vue')
		}
	]
});
